import { SimpleHorizontalListAppearanceType, SimpleHorizontalListBgColorType, SimpleHorizontalListTitleSize, SimpleHorizontalListWidgetConfigData } from "./simple-horizontal-list-widget.model";

export const getSimpleHorizontalListWidgetConfigData = (inputData: SimpleHorizontalListWidgetConfigData): SimpleHorizontalListWidgetConfigData => {
	return {
		...defaultConfig,
		...inputData,
	}
};

const defaultConfig: SimpleHorizontalListWidgetConfigData = {
	backgroundColorType: SimpleHorizontalListBgColorType.Default,
	cardAppearanceType: SimpleHorizontalListAppearanceType.Raised,
	titleSize: SimpleHorizontalListTitleSize.Default,
	isEditable: false,
};
